import React, { useEffect } from 'react'
import './homeSecFour.scss'
import ContactForm from '../../component/ContactForm/contactForm'
import iconone from '../../assest/callphone.gif';
import icontwo from '../../assest/email.gif';
import iconthree from '../../assest/address.gif';
import { com, contact } from '../../data/MainData'
import Aos from 'aos';

export const HomeSecFour = () => {
    useEffect(() => {
        Aos.init({
          duration: 1000,       
          easing: "ease-out", 
          once: true,         
        });
      }, []);

  return (
    <div id='contact' className='secFour-container'>
    <div className='ContactMeContainer'>
       <div data-aos="fade-up">
        <p className='TitleNameOne'>Contact Me -</p>
        <div className='ContactMeTitleName'>
          <p className='TitleTwo'>{contact.lets} </p>
          <p className='TitleThree'>{contact.connect},</p>
        </div>
      </div>
      <div className="ContactMeBackground">
        <div className='ContactMeInner'>
          <div className="ContactMeLeftSection" data-aos="fade-up">

            <div className='iconinner'>
              <div className='Iconsection'>
                <span className="icon">
                  <img id='iconimg' src={iconone} alt="fireSpot" />
                </span>
              </div>
              <div className='DetailsTitle'>
                <p className='PrimaryTitle'>{contact.phone} </p>
                <p className='SecondTitle'>{com.tel} </p>
              </div>
            </div>

            <div className='iconinner'>
              <div className='Iconsection'>
                <span className="icon">
                  <img id='iconimg' src={icontwo} alt="fireSpot" />
                </span>
              </div>
              <div className='DetailsTitle'>
                <p className='PrimaryTitle'>{contact.mail} </p>
                <p className='SecondTitle'>{com.mail} </p>
              </div>
            </div>

            <div className='iconinner'>
              <div className='Iconsection'>
                <span className="icon">
                  <img id='iconimg' src={iconthree} alt="fireSpot" />
                </span>
              </div>
              <div className='DetailsTitle'>
                <p className='PrimaryTitle'>{contact.address} </p>
                <p className='SecondTitle'>{com.location} </p>
              </div>
            </div>

          </div>

          <div className="ContactMeCRightSection" data-aos="fade-up">
          <div className='con-form'>
          <ContactForm/>
          </div>
          

          </div>
        </div>

      </div>
    </div>
    </div>
  )
}

export default HomeSecFour;